/**
 * @file Album Folder Purchase Identity Tag Selection container.
 */

import { connect } from 'react-redux';
import get from 'lodash.get';

import AlbumFolderPurchaseIdentityTagSelection from '../../../components/purchase/album-folder-purchase/AlbumFolderPurchaseIdentityTagSelection';
import {
  selectTag,
  deselectTag,
} from '../../../actions/identity-tag-selection';
import { openModal } from '../../../actions/modal-actions';
import { getUploadedPhotoByIdentity } from '../../../util/photo-upload';

const mapStateToProps = ({ identityTagSelection, photoUploads }, ownProps) => ({
  selectedTags: get(
    identityTagSelection.identities.find(
      ({ id }) => id === ownProps.identity.id,
    ),
    'tags',
    [],
  ),
  uploadedPhoto: getUploadedPhotoByIdentity(
    photoUploads.photos,
    ownProps.identity,
  ),
});

const mapDispatchToProps = {
  selectTag,
  deselectTag,
  openModal,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(AlbumFolderPurchaseIdentityTagSelection);
